import { cloudFunctionsAxios } from './axios';

// Test function to verify auth token is being added
export const testAuthToken = async (flowId: string) => {
  try {
    // Make a POST request to archive flow endpoint
    const response = await cloudFunctionsAxios.post('/archiveFlows', {
      flow_id: flowId,
    });
    console.log('Auth test successful:', response.data);
    return response.data;
  } catch (error: any) {
    // Log the full error response for debugging
    console.error('Auth test failed:', {
      message: error.message,
      response: error.response?.data,
      headers: error.config?.headers, // This will show if the auth token was added
    });
    throw error;
  }
};

// Test function that makes a request and logs the headers
export const debugAuthToken = async (flowId: string) => {
  try {
    // Make a request to archive flow endpoint
    await cloudFunctionsAxios.post('/archiveFlows', {
      flow_id: flowId,
    });
  } catch (error: any) {
    // Even if request fails, we can still see if auth header was added
    if (error.config?.headers?.Authorization) {
      console.log('Auth header found:', {
        Authorization: error.config.headers.Authorization,
        requestData: error.config.data, // Show the request payload
      });
      return error.config.headers;
    } else {
      console.error('No auth header found in request');
      throw new Error('No auth header found');
    }
  }
};
